import { useState } from "react";
import { MD, tryParseErrorResponse } from "../http/monatsdatenApi";

const useFormError = <T, U>(
  onSubmit: (body: T) => Promise<U>,
  onClose: () => void,
) => {
  const [error, setError] = useState<MD.ErrorResponse | undefined>();

  return {
    handleSubmit: (body: T, onSuccess: (res: U) => void) => {
      setError(undefined);
      onSubmit(body)
        .then(onSuccess)
        .catch((err: unknown) => setError(parseErrorResponse(err)));
    },
    handleClose: () => {
      setError(undefined);
      onClose();
    },
    error,
  };
};

const parseErrorResponse = (err: unknown): MD.ErrorResponse =>
  tryParseErrorResponse(err) ?? {
    error: { code: 500, message: "unable to parse error response" },
  };

export default useFormError;
